import { sendFandomAnalyticsEvent } from "src/modules/fandom_analytics_module.js";
import { generateToken } from "src/modules/recaptcha_v3_module.js"
import { VodafoneLab } from "./vodafone_lab_module.js";
import { get } from "lodash";

const vodafoneLabBasicMixin = {
  methods: {
    trackingButtonUrl(event, buttonTracking, buttonEventCookie) {
      let trackingInfo = buttonTracking || this.content.button_tracking;
      let eventCookieInfo = buttonEventCookie || this.content.button_event_cookie;
      if (!!trackingInfo) {
        const trackingParams = trackingInfo.split(",");
        sendFandomAnalyticsEvent(trackingParams[0], trackingParams[1], trackingParams[2]);
      }

      if (!!eventCookieInfo) {
        document.cookie = `vodafone_lab_user_tag=${eventCookieInfo}; path=/;`;
      }

      const target = $(event.currentTarget);
      const href = target.attr("href");

      if (href == "javascript:void(0)") {
        return false;
      }

      if (target.attr("target") == "_blank") {
        window.open(href, '_blank');
      } else {
        window.location.href = href;
      }
      return false;
    },
  },
  computed: {
    lastUpdatedAt() {
      const options = { month: 'long', year: 'numeric' };
      if (this.content.last_updated_at) {
        return new Date(this.content.last_updated_at).toLocaleDateString('it-IT', options);
      } else {
        return null;
      }
    },
    category() {
      return this.categoryContent ? this.categoryContent.title : (this.content.category || "");
    },
    categoryIcon() {
      return this.categoryContent ? this.categoryContent.icon : this.content.category_icon;
    },
    categoryContent() {
      const decorator = Fandom.getDecorator(this.content, 'label') || Fandom.getDecorator(this.content, 'category');
      if (!!decorator) {
        return decorator;
      } else {
        const categoryContent = Fandom.getContent(this.content.category || "");
        if (!!categoryContent) {
          return categoryContent;
        } else {
          return false;
        }
      }
    }
  }
};

const vodafoneLabNewsletterMixin = {
  data: function() {
    return {
      form: {
        success: false,
        errors: [],
        loading: false,
        data: {
          email: "",
          area: ""
        }
      }
    };
  },
  methods: {
    getFormField(fieldName) {
      return this.formFields.filter(field => field.name == fieldName)[0];
    },
    getFormData () {
      const formData = new FormData();
      this.formFields.forEach(field => {
        if (field.type == "hidden") {
          formData.append(this.getFieldInputName(field.name), field.value);
        } else {
          const formDataValue = this.form.data[field.name];
          if (formDataValue) {
            formData.append(this.getFieldInputName(field.name), formDataValue);
          }
        }
      });

      formData.append("interaction_id", this.content.interaction.id);
      formData.append("content_id", this.containerContent.id);

      return formData;
    },
    getFieldInputName(fieldName) {
      return `user_upload_interaction[${fieldName}]`;
    },
    submitSimpleForm(event) {
      if (!this.form.loading) {
        this.form.success = false;
        this.form.loading = true;
        this.form.errors = [];

        let submitForm = (token) => { 
          const data = this.getFormData();
          if (token)
            data.append("recaptcha_enterprise_token", token);

          Fandom.ajax({
              processData: false,
              contentType: false,
              method: "POST",
              url: "/upload_simple_form",
              data: data,
              success: (data) => {
                this.form.success = data.success;
                if (this.form.success) {
                  sendFandomAnalyticsEvent("Newsletter", "Newsletter Registration", this.form.data.area);
                  this.$emit('subscribed', {label: this.form.data.area});
                  this.form.data = {};
                  Fandom.setCookie('vodafone-lab-newsletter-subscribed', true);
                  
                  if (!!window.wa_gc) {
                    const digitalData = Fandom.deepClone(window.digitalData);
                    digitalData.link_name = `${VodafoneLab.getPageName()}:Newsletter subscription:TYP`;
                    window.wa_gc(digitalData, "link");
                    console.log("%cExecuted wa_gc(digitalData, 'link')", "background: #222; color: #bada55; padding: .5rem;", digitalData);
                  }

                  $("#modal-newsletter").modal("hide");
                } else {
                  this.form.errors = data.errors;
                }
              }
            },
            () => {
              this.form.loading = false;
            }
          );
        };
        if (globalState.pageModel.aux.recaptcha_enterprise) {
          generateToken(submitForm, "submit");
        } else {
          submitForm();
        }
      }
    },
  },
  computed: {
    layoutContent() {
      return globalState.pageModel.layout.content;
    },
    formFields() {
      return JSON.parse(this.content.form_fields).fields;
    },
    areaDropdown() {
      const data = this.getFormField("area");
      return Fandom.exists(data) && data.type === "dropdown" ? data : false;
    },
    newsletterRecord() {
      return Fandom.retrieveFromGlobalState("newsletter", false);
    }
  }
}

const vodafoneLabAuthorizationMixin = {
  computed: {
    relatedContent() {
      return get(this, ["pageMode", "name_to_content", this.content.sealable_content], false);
    },
    sealedContent() {
      return this.relatedContent ? this.relatedContent : this.content;
    },
    authorization() {
      return get(this.pageModel, ["name_to_content_authorization", this.sealedContent.name], false);
    },
    authorized() {
      return get(this, ["authorization", "authorized"], true);
    },
    authType() {
      return get(this, ["authorization", "type"], false);
    },
  },
  methods: {
    mayRedirectOnFreeContent(redirectWhenUnlocked = false) {
      sendFandomAnalyticsEvent("Content Interaction", "Obtain Button Click", this.containerContent.name);
      if (this.authorized || (Fandom.isUserRegistered() && this.authType === "user_contents")) {
        sendFandomAnalyticsEvent("Content Interaction", "Content Obtained", this.containerContent.name);
      } else {
        // Fandom.emit("toggle-registration-modal");
        if (this.authType === "registration" || !Fandom.isUserRegistered()) {
          Fandom.emit("toggle-registration-modal");
        } else if (this.authType === "user_group"){
          Fandom.emit("modal-user-group-required", this.sealedContent);
        }
      }
    }
  }
};

/* Warning: makes use of `this.mainContent`, so fandom basic mixin is required */
const vodafoneLabContactMixin = {
  mounted() {
    if (this.$options.name.startsWith("Page")) {
      const action = this.getParentLabels('topic-');
      const category = this.getParentLabels('target-');
      sendFandomAnalyticsEvent(category, action, this.content.name);
    }
  },
  methods: {
    getParentLabels(prefix) {
      return this.content.parent_names
        .filter(name => name.indexOf(prefix) == 0)
        .map(name => name.slice(prefix.length))
        .map(name => name.split('-').map(str => Fandom.capitalize(str)).join(''))
        .join('-')
    },
  },
  computed: {
    isSoho() {
      return this.mainContent.name.includes("soho") || this.mainContent.parent_names.includes('target-soho');
    },
    isSme() {
      return this.mainContent.name.includes("sme") || this.mainContent.parent_names.includes('target-sme');
    },
    isCorporate() {
      return this.mainContent.name.includes("corporate") || this.mainContent.parent_names.includes('target-corporate');
    },
    isPubblicaAmministrazione() {
      return this.mainContent.name.includes("pubblica-amministrazione") || this.mainContent.parent_names.includes('target-pubblica-amministrazione');
    },
    sohoRecord() {
      return Fandom.getContent(Fandom.retrieveFromGlobalState("soho_contact_content", '')) || {};
    },
    corporateRecord() {
      return Fandom.getContent(Fandom.retrieveFromGlobalState("corporate_contact_content", '')) || {};
    },
    contactButton() {
      if (this.content.hide_contact_button) return false;
      if ((this.isSoho || this.isSme) && !this.content.force_corporate_contact_button) {
        return this.sohoRecord.button;
      } else {
        return this.corporateRecord.button;
      }
    },
    contactStripe() {
      if (this.content.show_corporate_contact_stripe) {
        return this.corporateRecord;
      } else {
        if (this.isSoho || this.isSme) {
          return false;
        }
        if (!(this.isSoho || this.isSme) && (this.isCorporate || this.isPubblicaAmministrazione)) {
          return this.corporateRecord;
        }
      }
    }
  }
};

const vodafoneLabRootMixin = {
  methods: {
    require2faCode() {
      Fandom.ajax({
        method: "GET",
        url: "/api/v5/2fa/get_code",
        success: data => {
          alert("Codice reinviato");
        },
        error: err => {
          console.error(err);
        }
      });
    }
  }
};

export {
  vodafoneLabBasicMixin,
  vodafoneLabNewsletterMixin,
  vodafoneLabAuthorizationMixin,
  vodafoneLabContactMixin,
  vodafoneLabRootMixin
};
